import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { Zone } from '../model/types';

interface Params {
  page?: number;
  limit?: number;
  search?: string;
  orderBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export const getPaginatedZonesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPaginatedZones: builder.query<Pagination<Zone>, { warehouseId: string } & Params>({
      query: ({ warehouseId, ...params }) => ({
        url: `/warehouses/${warehouseId}/zones`,
        params,
      }),
      providesTags: ['Zones'],
    }),
  }),
});

export const { useGetPaginatedZonesQuery } = getPaginatedZonesApi;
